export const truckTypeOptions = [
	{label: "Open", value: "open"},
	{label: "Closed", value: "closed"},
]
